/* eslint-disable camelcase */
import dayjs from 'dayjs'

import { defaultViewDateFormat } from 'shared/constants'
import { IProfile, IServerProfile, IServerUserInfo, IUserInfo } from 'shared/models/Profile'

import { IDefaultDataResponse } from '../PaymentApi/types/types'
import { IConvertedTransactions, ISlotsHistory, ISlotsHistoryDTO, ITransactionListItemDTO } from './types/types'

export class ProfileConverter {
  convertProfileInfo(data: IServerProfile): IProfile {
    return {
      id: data.id,
      username: data.username,
      dateJoined: dayjs(data.date_joined).format('DD/MM/YYYY'),
      balanceCurrency: data.balance_currency,
      balance: data.balance,
      isBanned: data.is_banned,
    }
  }

  convertUserInfo(data: IServerUserInfo): IUserInfo {
    return {
      firstName: data.first_name,
      lastName: data.last_name,
      dateOfBirth: data.date_of_birth,
      mobileNumber: data.mobile_number,
      postalCode: data.postal_code,
      streetAddress: data.street_address,
      country: data.country,
      city: data.city,
      gender: data.gender,
    }
  }

  convertTransfersList = (data: IDefaultDataResponse<ITransactionListItemDTO>): IConvertedTransactions => {
    const list =
      data?.results?.map(item => {
        const {
          id,
          sender,
          recipient,
          status,
          amount,
          balance_after,
          balance_before,
          completed_at,
          created_at,
          bonus_player_currency_amount,
          is_percentage,
          bonus,
        } = item

        return {
          id,
          fromId: sender.id,
          toId: recipient.id,
          amount: +(+amount).toFixed(2),
          bonus: bonus_player_currency_amount ? +(+bonus_player_currency_amount).toFixed(2) : undefined,
          bonusPercentage:
            is_percentage && bonus ? ((+bonus * 100) / (+amount - +bonus)).toFixed(2).replace('.', ',') : undefined,
          balanceBefore: balance_before,
          balanceAfter: balance_after,
          date: dayjs(created_at).format(defaultViewDateFormat),
          createdAt: dayjs(created_at).format(defaultViewDateFormat),
          completedAt: dayjs(completed_at).format(defaultViewDateFormat),
          status,
          type: item.deposit?.amount ? 'deposit' : 'withdrawal',
        }
      }) || []

    return {
      page: data.page,
      count: data.count,
      history: list,
    }
  }

  convertSlotsHistory = (data: ISlotsHistoryDTO): ISlotsHistory => {
    const items =
      data.results.map(item => ({
        routeProvider: item.provider,
        provider: item.producer === 'Slots' ? 'otherSlots' : item.producer,
        date: dayjs(item.date).format(defaultViewDateFormat),
        balance: `${Math.floor(+item.balance_before * 100) / 100} → ${Math.floor(+item.balance_after * 100) / 100} ${
          item.balance_after_currency
        }`,
        status: item.status,
        betAmount: `${Math.floor(+item.bet_amount * 100) / 100}`,
        winAmount: `${Math.floor(+item.win_amount * 100) / 100}`,
        gameId: item.game_id.replace('_mobile', ''),
      })) || []
    return {
      count: data.count,
      items,
    }
  }
}
